/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {UnitNumberFieldViewer} from "./UnitNumberFieldViewer";
import {service as EnvironmentalBenefitService} from "../../../Services/EnvironmentalBenefitService";
import {usePrimeCache} from "../../../Hooks/ServiceHooks";

export const ProgramEnvironmentalBenefitsTargetValueViewer = (props) => {
	const {
		Data,
		environmentalBenefitId = Data?.environmentalBenefitId ?? -1,
	} = props;
	
	usePrimeCache([EnvironmentalBenefitService]);

	const selectedBenefit = EnvironmentalBenefitService.CachedValueById(environmentalBenefitId)?.result;

	return <UnitNumberFieldViewer
		{...props}
		unitId={selectedBenefit?.unitId ?? -1}
	/>;
}
